import script from "./PublicProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicProjects.vue?vue&type=script&setup=true&lang=js"

import "./PublicProjects.vue?vue&type=style&index=0&id=51d5265c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d5265c"]])

export default __exports__